var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module cercaliagl/control/ZBE
 */
import Control from './Control';
import MapControls from './MapControls';
import { i18n } from '../dictionary';
import VControlButton from '../view/VControlButton';
import ZBELayer from '../layer/ZBE';
import VZBEPopup from '../view/VZBEPopup';
/**
 * @classdesc
 * <b>Javascript ES5</b>
 * ```js
 * const control = new cercaliagl.control.Traffic();
 * ```
 * <br/>
 * This control allow to display real traffic and forecast traffic.
 * <br/>
 * - In real traffic most roads display linestrings over them. In the bottom right dialog you can see the legend.
 *   Traffic affectations like accidents, network managements are displayed too.
 * - In forecast traffic you can adjust the date and the forecast time.
 */
var ZBE = /** @class */ (function (_super) {
    __extends(ZBE, _super);
    /**
     * @constructor
     * @api
     */
    function ZBE() {
        var _this = this;
        var controlButton = new VControlButton('zbe', ['path1', 'path2', 'path3', 'path4', 'path5', 'path6', 'path7', 'path8', 'path9', 'path10', 'path11', 'path12', 'path13', 'path14', 'path15', 'path16', 'path17', 'path18', 'path19', 'path20']);
        var element = controlButton.getElement();
        _this = _super.call(this, {
            element: element,
            className: 'cercaliagl.control.ZBE',
            name: MapControls.ZBE,
        }) || this;
        /**
         * @private
         * @type {boolean}
         */
        _this.enabled_ = false;
        /**
         * @private
         * @type {VControlButton}
         */
        _this.controlButton_ = controlButton;
        /**
         * @private
         * @type {ZBELayer}
         */
        _this.layerZBE_ = null;
        /**
         * @private
         * @type {HTMLElement}
         */
        _this.element_ = element;
        /**
         * @private
         * @type {VZBEPopup}
         */
        _this.zbePopup_ = new VZBEPopup();
        _this.initialize_();
        return _this;
    }
    /**
     * @private
     */
    ZBE.prototype.initialize_ = function () {
        this.controlButton_.setTooltip(i18n('tooltipZBE'));
        this.element_.addEventListener('click', this.handleClick_.bind(this));
    };
    /**
     * @private
     */
    ZBE.prototype.handleClick_ = function () {
        if (!this.enabled_) {
            this.enable();
        }
        else {
            this.disable();
        }
    };
    /**
     * Enable traffic control. Default enabled mode is live traffic.
     * @override
     * @api
     */
    ZBE.prototype.enable = function () {
        if (!this.layerZBE_) {
            this.createZBE_();
        }
        else {
            this.layerZBE_.setVisible(true);
        }
        this.enabled_ = true;
        this.controlButton_.enable();
        if (!this.zbePopup_.getElement().closest('body')) {
            var container = this.getMap().getContainer();
            this.zbePopup_.appendTo(container);
        }
    };
    /**
     * Disable traffic control.
     * @override
     * @api
     */
    ZBE.prototype.disable = function () {
        this.getCercaliaMap().removeLayer(this.layerZBE_);
        this.layerZBE_ = null;
        this.enabled_ = false;
        this.controlButton_.disable();
        if (this.zbePopup_ && this.zbePopup_.isVisible()) {
            this.zbePopup_.hide();
        }
    };
    /**
     * @private
     */
    ZBE.prototype.createZBE_ = function () {
        var _this = this;
        if (!this.layerZBE_) {
            var cercaliaMap = this.getCercaliaMap();
            this.layerZBE_ = new ZBELayer();
            cercaliaMap.addLayer(this.layerZBE_);
            this.getMap().on('click', 'zbe', function (e) { return _this.handleLayerClick_(e); });
            // this.moveLayers_();
        }
    };
    /**
     * @private
     * @param {Event} e Event
     */
    ZBE.prototype.handleLayerClick_ = function (e) {
        var features = this.map_.queryRenderedFeatures(e.point, {
            layers: ['zbe'],
        });
        if (features.length === 0) {
            return;
        }
        var properties = features[0].properties;
        this.zbePopup_.update(properties);
        if (!this.zbePopup_.isVisible()) {
            this.viewInterface_.closePopups();
            this.zbePopup_.show();
        }
    };
    /**
     * @private
     */
    ZBE.prototype.removeZBE_ = function () {
        var cercaliaMap = this.getCercaliaMap();
        if (this.layerZBE_) {
            cercaliaMap.removeLayer(this.layerZBE_);
            this.layerZBE_ = null;
        }
    };
    /**
     * Close
     * @api
     */
    ZBE.prototype.closePopup = function () {
        this.zbePopup_.hide();
    };
    return ZBE;
}(Control));
export default ZBE;
//# sourceMappingURL=ZBE.js.map